import { defineStore } from 'pinia'

import { api } from '@/api'
import { hotReloadStore } from '@/utils/build'

export const useSignatureStore = defineStore('signature', {
  state: () => ({
    luid: '',
    client_id: '',
    signature_url: '',
    name: '',
    program: '',
  }),

  getters: {
    hasParams: (state) => !!state.luid,
    baseURL: (state) => state.program ? `/${state.program}/api/v1` : '/api/v1',
  },

  actions: {
    async requestSignature (newName?: string): Promise<void> {
      if (newName) this.name = newName
      const res = await api.attachments.request_signature({ body: { name: this.name, luid: this.luid } }, { baseURL: this.baseURL })
      this.signature_url = res.data.sign_url
      this.client_id = res.data.hellosign_client_id
    },
    cancelSignature (): ReturnType<typeof api.attachments.cancel_signature> {
      return api.attachments.cancel_signature({ body: { luid: this.luid } }, { baseURL: this.baseURL })
    },
    markSigned (signatureId: string): ReturnType<typeof api.attachments.signed> {
      return api.attachments.signed({
        path: { sig_id: signatureId },
        body: { confirmed: false },
      }, { baseURL: this.baseURL })
    },
    async fetchAttachment (luid: string) {
      const res = await api.attachments.fetch({ path: { luid } }, { baseURL: this.baseURL })
      this.luid = luid
      return res.data
    },
  },
})

hotReloadStore(useSignatureStore)
